module.exports = __webpack_public_path__ + "images/organization/team-members.47bfc1097964d16b256b.svg";